import { z } from "zod";
import { EventParticipantIdPublicSchema } from "./branded-id.schemas.js";
import { ParticipantDataIssueType } from "../types/participant-data-issue.types.js";
import { DemoPersonaSeedSummarySchema } from "./demo-persona-seed-summary.schemas.js";
import { paginatedResponseSchema } from "./paginated.schemas.js";

export const ParticipantDataIssueSchema = z.object({
  type: z.enum(ParticipantDataIssueType),
  value: z.string(),
  participantIdPublics: z.array(EventParticipantIdPublicSchema),
});

export function paginatedParticipantListSchema<ItemSchema extends z.ZodTypeAny>(
  itemSchema: ItemSchema,
) {
  return paginatedResponseSchema(itemSchema).extend({
    dataIssues: z.array(ParticipantDataIssueSchema).readonly(),
    // Must be in the parse schema, not just the response interface: the frontend
    // list query parses through this schema, and zod strips unknown keys.
    demoPersonaSummary: DemoPersonaSeedSummarySchema.optional(),
  });
}
